export const PARTNER_EXCEL_HEADERS = [
  "パートナー管理番号",
  "パートナー名",
  "項目名",
  "国籍",
  "郵便番号",
  "町名丁目番地号等",
  "所在地",
  "担当者名",
  "連絡方法",
  "電話番号",
  "メールアドレス",
  "その他の連絡先",
  "契約情報",
  "請求情報",
  "メモ",
];

export const PARTNER_EXCEL_COLUMN_WIDTHS = [25, 25, 30, 20, 15, 30, 30, 18, 15, 18, 25, 25, 30, 30, 30];

export const PARTNER_NATIONALITY_COLUMN = "D";

export const PARTNER_CONTACT_METHOD_COLUMN = "I";
